import type { AgentUpdateRequest, RoomUpdateRequest } from '@/types/request'

export function toRoomFormData(data: RoomUpdateRequest): FormData {
  const formData = new FormData()
  const staticFormDataKeys = [
    'name',
    'description',
    'custom_prompt',
    'model_version_id',
    'agent_id',
    'department_id',
    'is_answer_internal_data_only',
    'is_allow_any_users_in_department_or_company',
    'use_company_files',
  ] as const

  for (const key of staticFormDataKeys) {
    if (data[key] === undefined || data[key] === null) continue

    formData.append(key, String(data[key]))
  }
  for (const key of ['member_ids', 'company_file_ids', 'company_folder_ids', 'unassign_file_ids'] as const) {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key].join(','))
    }
  }
  data.upload_documents?.forEach((doc) => formData.append('files', doc.file))
  return formData
}

export function toAgentFormData(data: AgentUpdateRequest): FormData {
  const formData = new FormData()
  const staticFormDataKeys = [
    'name',
    'description',
    'model_version_id',
    'is_speak_first',
    'integration_session_timeout_message',
    'instructions',
    'base_style_and_tone',
    'warmth',
    'enthusiasm',
    'headers_and_lists',
    'emoji',
    'custom_instructions',
  ] as const

  for (const key of staticFormDataKeys) {
    if (data[key] === undefined || data[key] === null) continue

    formData.append(key, String(data[key]))
  }

  if (data.integration_session_timeout_minutes !== undefined) {
    formData.append(
      'integration_session_timeout_minutes',
      data.integration_session_timeout_minutes === null ? 'null' : String(data.integration_session_timeout_minutes),
    )
  }
  if (data.session_category_id !== undefined) {
    formData.append(
      'session_category_id',
      data.session_category_id === null ? 'null' : String(data.session_category_id),
    )
  }
  if (data.auto_filled_data !== undefined && data.auto_filled_data !== null) {
    formData.append('auto_filled_data', JSON.stringify(data.auto_filled_data))
  }
  if (data.tools !== undefined && data.tools !== null) {
    formData.append('tools', JSON.stringify(data.tools))
  }
  return formData
}

export function getErrorMessage(error: unknown): string | undefined {
  if (typeof error === 'string') return error
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message
    if (typeof message === 'string') return message
  }
  return undefined
}
